import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { ShieldCheck, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="pt-16 pb-16 px-6 md:pt-24 md:pb-24 max-w-4xl mx-auto text-center" data-id="element-102">
      {/* Product Image */}
      <FadeIn data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative max-w-md mx-auto mb-10" data-id="element-104">
          <div className="absolute -inset-4 bg-sage/20 rounded-3xl -z-10 rotate-2" data-id="element-105"></div>
          <img src="https://cdn.magicpatterns.com/uploads/4NgdxYWbyuMoWXUcuEjDaB/SOS_RESET_MET_402B_IMAGE.png" alt="Mujer 40+ frente al espejo con audiobook SOS Reset Metabólico 40+" className="w-full h-auto rounded-3xl shadow-2xl object-cover" data-id="element-106" />
        </motion.div>
      </FadeIn>

      {/* CTA Button below image */}
      <FadeIn delay={0.2} data-id="element-107">
        <div className="flex flex-col items-center gap-4 mb-12" data-id="element-108">
          <Button data-id="element-109">QUIERO MI RESET METABÓLICO AHORA</Button>
        </div>
      </FadeIn>

      {/* Title */}
      <FadeIn delay={0.4} data-id="element-110">
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-charcoal leading-tight mb-6" data-id="element-111">
          El Botón del Pantalón que no Cierra:{' '}
          <span className="text-terracotta italic" data-id="element-112">
            No es tu Falta de Voluntad, son tus Hormonas.
          </span>
        </h1>
      </FadeIn>

      {/* Subtitle */}
      <FadeIn delay={0.5} data-id="element-113">
        <h2 className="font-sans text-lg md:text-xl text-charcoal/80 leading-relaxed max-w-2xl mx-auto mb-8" data-id="element-114">
          El Protocolo de 14 Días diseñado para Mujeres 40+ que quieren
          Desinflamar el Abdomen y Recuperar su Energía sin Dietas de Hambre.
        </h2>
      </FadeIn>

      {/* Trust line at the foot */}
      <FadeIn delay={0.6} data-id="element-115">
        <div className="flex items-center justify-center gap-4 text-sm text-charcoal/60 font-medium" data-id="element-116">
          <span className="flex items-center gap-1.5" data-id="element-117">
            <ShieldCheck size={16} className="text-terracotta" data-id="element-118" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-119">
            <Zap size={16} className="text-terracotta" data-id="element-120" /> Acceso instantáneo
          </span>
        </div>
      </FadeIn>
    </section>;
}